// extracted by mini-css-extract-plugin
module.exports = {"name":"RealName_name__3jW9l"};